import { EntityClassList } from '../entity-class-list';
import { Clock } from './clock';
import { PotionOfStrength } from './potion-of-strength';
import { RallyingFlag } from './rallying-flag';

export const ITEMS = new EntityClassList([
    Clock, RallyingFlag, PotionOfStrength
]);